import React from 'react';
import PropTypes from 'prop-types';

export const Processed = ({ width, height, ...props }) => (
  <svg
    data-icon='processed'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='m2 20 6-8-6-8h13a1.986 1.986 0 0 1 1.6.8L22 12l-.125.175c-.45-.3-.938-.546-1.462-.738a7.216 7.216 0 0 0-1.638-.387L15 6H6l4.5 6L6 18h5c0 .35.025.692.075 1.025.05.333.125.658.225.975H2Zm15.275.25 3.475-3.45-1.05-1.05-2.425 2.375-.975-.975-1.05 1.075 2.025 2.025ZM18 23c-1.383 0-2.563-.488-3.537-1.462C13.488 20.562 13 19.383 13 18s.488-2.563 1.463-3.537C15.438 13.488 16.617 13 18 13s2.563.488 3.538 1.463C22.512 15.438 23 16.617 23 18s-.488 2.563-1.462 3.538C20.562 22.512 19.383 23 18 23Z'
    />
  </svg>
);

Processed.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Processed.defaultProps = {
  width: 24,
  height: 24,
};
